// External Libraries
import React from "react";

class ClassificationDropdown extends React.Component {
	render() {
		const {
			transaction,
			classification,
			activeClassificationDropdown,
			sortedClassifications,
			handleClassificationClick,
			handleClassificationChange
		} = this.props;

		return (
			<div className="classification-wrapper">
				<div onClick={event => handleClassificationClick(transaction, event)}>{classification || "Unclassified"}</div>
				{activeClassificationDropdown === transaction && (
					<div className="classification-dropdown">
						{sortedClassifications.map(c => (
							<div key={c.name} className={`dropdown-item`} onClick={() => handleClassificationChange(transaction, c.name)}>
								{c.name}
							</div>
						))}
					</div>
				)}
			</div>
		);
	}
}

export default ClassificationDropdown;
